const DesirabilityEvents = {
  hoveredIcon: 'Hovered Low Desirability Icon',
  hoveredPanel: 'Hovered Low Desirability Panel',
  clickedWhatsThis: "Clicked Low Desirability What's This",
};

export default DesirabilityEvents;
